import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export function HomeUsersCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>User Management</CardTitle>
      </CardHeader>
      <CardContent>
        Manage your team by adding or removing Boundless platform users to
        ensure the right people have access.
      </CardContent>
      <CardFooter>
        <Button asChild>
          <Link to={"/lender/users"}>View</Link>
        </Button>
      </CardFooter>
    </Card>
  )
}
